import { render } from "./ListeProduitRestreintPage.vue?vue&type=template&id=1e2694c2&ts=true"
import script from "./ListeProduitRestreintPage.vue?vue&type=script&lang=ts"
export * from "./ListeProduitRestreintPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__